var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLikeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33335 6.0013V14.0013H0.666687V6.0013H3.33335ZM6.00002 14.0013C5.6464 14.0013 5.30726 13.8608 5.05721 13.6108C4.80716 13.3607 4.66669 13.0216 4.66669 12.668V6.0013C4.66669 5.63463 4.81335 5.3013 5.06002 5.0613L9.44669 0.667969L10.1534 1.37464C10.3334 1.55464 10.4467 1.8013 10.4467 2.07464L10.4267 2.28797L9.79335 5.33464H14C14.3536 5.33464 14.6928 5.47511 14.9428 5.72516C15.1929 5.97521 15.3334 6.31435 15.3334 6.66797V8.0013C15.3334 8.17463 15.3 8.33463 15.24 8.48797L13.2267 13.188C13.0267 13.668 12.5534 14.0013 12 14.0013H6.00002ZM6.00002 12.668H12.02L14 8.0013V6.66797H8.14002L8.89335 3.1213L6.00002 6.0213V12.668Z",
    fill: "#2D91FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeIcon);
export default __webpack_public_path__ + "static/media/Like_Icon.8f0a1b92c97d0c8532d6efa666f70663.svg";
export { ForwardRef as ReactComponent };